import _uniqueID from 'lodash/uniqueId';
import _sumBy from 'lodash/sumBy';
import { Button, Icon, Modal, Row, Select } from 'grab-ui';
import I18n from 'i18n-js';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { paymentMethodForDisplay } from 'helper/payment';
import paymentIcon from 'components/booking/payment-field/payment-icon';
import { groupAndSumFailedPayments } from 'helper/failed-payment-helper';
import { formatMajorUnitsForDisplay } from 'helper/order';
import css from './failed-payments-modal.less';

const Option = Select.Option;

const FailedPaymentsRetryModal = ({
  failedPayments,
  failedPaymentsRetryStatus,
  setFailedPaymentsRetryStatus,
  paymentMethods,
  retryFailedPayments,
}) => {
  const [selectedPaymentMethodID, setSelectedPaymentMethodID] = useState(null);
  const {
    retryFailedPaymentsModalVisible,
    isLoading,
    isError,
    isSuccessful,
  } = failedPaymentsRetryStatus;

  // Retry just finished successfully
  if (isSuccessful) {
    window.location.reload();
  }

  const groupedPayments = groupAndSumFailedPayments(failedPayments);
  const totalsByCurrencyForDisplay = Object.keys(groupedPayments).map(
    currency => {
      const currencyGroup = groupedPayments[currency];
      const total = _sumBy(currencyGroup, 'total');
      return formatMajorUnitsForDisplay(total, {
        code: currencyGroup[0].currency,
      });
    },
  );
  //
  const handlePaymentMethodSelect = paymentMethodID => {
    setSelectedPaymentMethodID(paymentMethodID);
  };

  const handleCancel = () => {
    setFailedPaymentsRetryStatus({
      listFailedPaymentsModalVisible: false,
      retryFailedPaymentsModalVisible: false,
    });
  };
  const handleOk = () => {
    retryFailedPayments({ paymentTypeID: selectedPaymentMethodID });
  };
  return (
    <Modal
      className={css.modal}
      visible={retryFailedPaymentsModalVisible}
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          disable={isLoading}
          className={css.cancelButton}
        >
          {I18n.t('v2.failedPayments.selectPaymentCancel')}
        </Button>,
        <Button
          className={css.mainButton}
          key="submit"
          type="primary"
          onClick={handleOk}
          disabled={isLoading || !selectedPaymentMethodID}
        >
          {I18n.t('v2.failedPayments.selectPaymentProceed')}
        </Button>,
      ]}
      closable={false}
    >
      <Row>
        <p className={css.title}>
          {I18n.t('v2.failedPayments.selectPaymentTitle')}
        </p>
        <Select
          placeholder={I18n.t('v2.failedPayments.selectPaymentPlaceholder')}
          onSelect={handlePaymentMethodSelect}
          className={css.paymentSelect}
        >
          {paymentMethods.map(pm => (
            <Option
              key={`${_uniqueID()}-${pm.paymentMethodID}`}
              value={pm.paymentTypeID}
            >
              <img
                className={css.paymentIcon}
                src={paymentIcon[pm.type]}
                alt=""
              />
              <span>{paymentMethodForDisplay(pm, true)}</span>
            </Option>
          ))}
        </Select>
        {paymentMethods.length === 0 && (
          <div className={css.errorContainer}>
            <Icon type="exclamation-circle" />
            <span>
              {I18n.t('v2.failedPayments.selectPaymentNoPaymentMethods')}
            </span>
          </div>
        )}
        {isError && (
          <div className={css.errorContainer}>
            <Icon className={css.errorIcon} type="exclamation-circle" />
            <span>{I18n.t('v2.failedPayments.selectPaymentRetryFailure')}</span>
          </div>
        )}
        <div className={css.totalContainer}>
          <span>{I18n.t('v2.failedPayments.selectPaymentTotal')}</span>
          <span className={css.totalValues}>
            {totalsByCurrencyForDisplay.map(t => <p key={_uniqueID()}>{t}</p>)}
          </span>
        </div>
      </Row>
    </Modal>
  );
};
FailedPaymentsRetryModal.propTypes = {
  failedPayments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  failedPaymentsRetryStatus: PropTypes.shape({}).isRequired,
  setFailedPaymentsRetryStatus: PropTypes.func.isRequired,
  paymentMethods: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  retryFailedPayments: PropTypes.func.isRequired,
};

export default FailedPaymentsRetryModal;
